<template>
  <div class="wrap">
    <div class="container lnb">
      <div class="contents_wrap">
        <div class="contents">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-form-item label="분류명" prop="e_name">
              <el-input v-model="ruleForm.e_name"></el-input>
            </el-form-item>
            <el-form-item label="파일">
              <div class="el-input">
                <el-upload
                  action="#"
                  class="example_file"
                  list-type="picture"
                  :auto-upload="false"
                  :on-change="handleFileChange"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                  :file-list="file"
                >
                
                  <div>
                    <!--(최소넓이 630px , 비율:2:1)-->
                    <el-button type="primary" size="small">업로드</el-button>
                  </div>
                  <div class="el-upload__tip" style="color : red;" slot="tip">최소넓이 630px , 비율:2:1</div>
                </el-upload>
              </div>
              <!-- <div class="small_txt">
                <input type="file" id="filename"  class="file_input" ref="filename" multiple="multiple" style="display:none;"
                       v-on:change="setFile()"
                />
                <div class="input_file label_div"
                     @click="selectFile()"
                >
                  <el-button type="primary">파일 추가</el-button> 
                </div>
                <div class="files"
                     v-for="(item, index) in file"
                     :key="`f${index}`"
                >
                  <div class="file_name">
                    {{item.name}}&nbsp;&nbsp;&nbsp;&nbsp;
                    <el-button
                      size="mini"
                      type="danger"
                      @click="deleteFile(index, item)">삭제</el-button>
                  </div>

                </div>
              </div> -->
            </el-form-item>
            <el-form-item class="text-center">
              <el-button type="primary" @click="submitForm('ruleForm')">{{ e_idx ? '수정' : '등록' }}</el-button>
              <el-button @click="resetForm('ruleForm')">목록 </el-button>
            </el-form-item>
          </el-form>
        </div>
        <page-footer></page-footer>
      </div>
    </div>
    <el-dialog :visible.sync="modalVisible">
      <img width="100%" :src="modalUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
  import VuxAlert from '@/mixins/vux-alert';
  import util from '@/mixins/util';

  export default {
    name: "SafetyCreate",
    components: {},
    mixins: [ VuxAlert ],
    data() {
      return {
        e_idx : this.$route.params.e_idx,
        ruleForm: {
          e_name: '',
        },
        rules: {
          e_name: [
            { required: true, message: '필수 선택사항입니다.', trigger: 'blur' },
          ],

        },
        file : [],
        deleteFiles: [],
        modalUrl : null,
        modalVisible: false,
      };
    },
    mounted() {
      this.getExampleDetail();
    },

    methods: {
      initData() {
        this.ruleForm = {
          e_name: '',
        }
        this.e_idx = this.$route.params.e_idx;
        this.file = [];
      },
      handlePictureCardPreview(file) {
        if(this.returnHasVeideo(file.name)) {
          this.errorAlert('확대보기는 이미지파일만 가능합니다.')
          return false;
        }
        this.modalUrl = file.url;
        this.modalVisible = true;
      },
      getExampleDetail(){
        this.initData();
        if(this.e_idx){
          const params = {  e_idx : this.e_idx }
          this.$api.$examples.getExampleDetail(params).then( res => res.Data.Result.List).then(res => {
            this.ruleForm = {
              e_name: res.e_name,
            }
            if(res.hasOwnProperty('File') && res.File.length > 0) {
              res.File.forEach(file => {
                file.url = file.thumb_url;
                file.name = file.org_name;
                this.file.push(file)
              })
            }
          })
        }
      },

      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = this.ruleForm;
            this.ruleForm.e_idx = this.e_idx;

            if(this.ruleForm.e_idx){
              this.$api.$examples.updateExample(params).then( res => res.Data).then(async res => {
                if(res.status === true){
                  if(this.deleteFiles.length > 0) {
                    await this.apiFileDelete();
                  }
                  if(this.file.length !== 0){
                    await this.updateFile(this.e_idx);
                  }else{
                  }
                    await this.confirmStatus(0);
                }else{
                  this.errorAlert(res.reason);
                }
              })
            }else{
              this.$api.$examples.createExample(params).then( res => res.Data.Result).then( async res => {
                if(res.status === true){
                  if(this.file.length !== 0){
                    await this.updateFile(res.e_idx);
                  }else{
                  }
                    await this.confirmStatus(0)
                }else{
                  this.errorAlert(res.reason);
                }
              })
            }
          } else {
            this.validateAlert();
            return false;
          }
        });
      },
      handleFileChange(file, fileList) {
        let maxSize = 1024 * 1024 * 5;
        let type = file.raw.type.split('/');
        if(type[0] !== 'video' && type[0] != 'image') {
              this.errorAlert('jpg, png, mp4 파일만 가능합니다.');
          fileList.pop();
        }else if(type.length < 2 ||( type[1] !== 'jpeg' && type[1] !== 'png' && type[1] !== 'mp4')) {
              this.errorAlert('jpg, png, mp4 파일만 가능합니다.');
          fileList.pop();
        }else{
          this.file = fileList;
        }
      },
      handleRemove(file, fileList) {
        if(file.hasOwnProperty('a_idx')) {
          this.deleteFiles.push(file);
        }
        this.file = fileList;
      },
      async apiFileDelete(){
        return await this.deleteFiles.forEach( async delFile => {
          if(delFile.hasOwnProperty('a_idx')) {
            let params = { 'a_idx' : delFile.a_idx }
            return await this.$api.$file.deleteFile(params).then( res => res.Data).then(res => {
              if(res.status === true){
                // this.$delete(this.file, index);
              }else{
                this.errorAlert(res.reason);
              }
            })
          }
        })
        // if(key){
        //   let params = { 'a_idx' : key }
        //   this.$api.$file.deleteFile(params).then( res => res.Data).then(res => {
        //     if(res.status === true){
        //       this.$delete(this.file, index);
        //     }else{
        //       this.errorAlert(res.reason);
        //     }
        //   })
        // }else{
        //   $('#filename').val('');
        //   this.file = [];
        // }
      },
      returnHasVeideo(url) {
        if(url) {
          if(url.substr(url.length - 3) === 'mp4'){
            return true;
          }else{
            return false;
          }
        }else{
          return false;
        }
      },
      async updateFile(e_idx){
        let status = 0;
        return await util.each(this.file, async (item, index, allItems) => {
          if(item.hasOwnProperty('raw')){
            let formData = new FormData();
            formData.append('files', item.raw);
            // formData.append('v_idx', e_idx);
            formData.append('a_container_type', 'examples');
            formData.append('a_container_id', e_idx);
            await this.$api.$file.updateFile(formData).then(res => res.Data).then(res => {
              if (res.result.status === true) {
              } else {
                status = res.result.reason;
              }
              //마지막 일때 컨펌
              if (this.file.length === index + 1) {
                // this.confirmStatus(status);
              }
            })
          }else{
            this.updateAlert();
          }
        });
      },

      confirmStatus(status){
        if(status === 0){
          if(this.e_idx){
            let alertParams = {'element' : this, 'getDetail' : this.getExampleDetail}
            this.updateAlert(alertParams);
          }else{
            let alertParams = {'element' : this };
            this.saveAlert(alertParams);
          }
        }else{
          this.errorAlert(status);
        }
      },
      resetForm(formName) {
        window.history.back();
      }
    }
  }
</script>
